import React from 'react';
import './air-handler-icon.css';

export const AirHandlerIcon = () => (
  <div className="air-handler-icon">&nbsp;</div>
);
